import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

// Current user + org + entitlements. Cached and shared across the shell.
export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => api.me(),
    staleTime: 60_000,
  });
}
